import React, { useCallback } from "react";
import Accordion from "react-bootstrap/Accordion";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MeetingDetailsGridPanel from "./MeetingDetailsGridPanel";

/**
 * One status section: accordion header (title, count) + grid or loader + footer.
 */
export default function MeetingDetailsAccordionSection({
  section,
  sectionIndex,
  isLoading,
  datasource,
  columnDefs,
  defaultColDef,
  cellClickedListener,
  onGridReady,
  rowClassRules,
  onSelectionChanged,
  onSortChanged,
  onFilterChanged,
  gridRef,
  onRefreshSection,
}) {
  const e = section;
  const ROW_HEIGHT = 42;
  const GRID_OVERHEAD = 140;
  const MIN_HEIGHT = 250;
  const MAX_HEIGHT = 620;
  const rowCount = e.totalCount > 0 ? Math.min(e.totalCount, 12) : 10;
  const gridHeight = Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, GRID_OVERHEAD + rowCount * ROW_HEIGHT));

  const handleRefresh = useCallback(
    (evt) => {
      evt.stopPropagation();
      onRefreshSection?.(e.type);
    },
    [onRefreshSection, e.type]
  );

  return (
    <div className="accrdion-list" key={e.type}>
      <Accordion.Item eventKey={`${e.type}`} key={e.type}>
        <Accordion.Header>
          <Tooltip title="Refresh" arrow>
            <IconButton
              size="small"
              onClick={handleRefresh}
              sx={{
                mr: 1,
                p: 0.5,
                color: "inherit",
                "&:hover": { color: "#1976d2" },
                transition: "color 0.2s, transform 0.2s",
                "&:hover svg": { transform: "rotate(180deg)" },
              }}
            >
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {e.type}
          {e.totalCount > 0 && ` (${e.totalCount})`}
        </Accordion.Header>
        <Accordion.Body>
          <MeetingDetailsGridPanel
            section={e}
            sectionIndex={sectionIndex}
            isLoading={isLoading}
            datasource={datasource}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            cellClickedListener={cellClickedListener}
            onGridReady={onGridReady}
            rowClassRules={rowClassRules}
            onSelectionChanged={onSelectionChanged}
            onSortChanged={onSortChanged}
            onFilterChanged={onFilterChanged}
            gridRef={gridRef}
            gridHeight={gridHeight}
          />
        </Accordion.Body>
      </Accordion.Item>
    </div>
  );
}
